export enum SignerPermissons {
  SIGNING_AUTHORITY = 'SIGNING_AUTHORITY',
  COURT_ENFORCEMENT = 'COURT_ENFORCEMENT',
}

export interface ISignerPermisson {
  createdDate: string;
  startDate: string;
  expiryDate: string;
  totalThreshold: number;
  countApprove: number;
  isApproved: boolean;
  type: SignerPermissons;
  isActive: boolean;
  signedBySigner: boolean;
  signedByGeneralManager: boolean;
  needSign: boolean;
}

export interface ISignerInfo {
  userId: number;
  displayName: string;
  fullName: string;
  rank: string;
  isMainSigner: boolean;
  permissions: {
    [key in keyof typeof SignerPermissons]: ISignerPermisson;
  };
}

export const PermissionToLabel: {
  [key in keyof typeof SignerPermissons]: string;
} = {
  COURT_ENFORCEMENT: 'Исполнение решений суда',
  SIGNING_AUTHORITY: 'Подписание полномочий',
};
